import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";
import * as moment from "moment";

import BOText from "app/components/BOComponents/BOText/BOText";

class Summary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      data: null,
    };

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.props.data.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({ data: fetchMoreResult.payments[0] });
        let time = moment(fetchMoreResult.payments[0].created_at);
        let weekTest = moment()
          .subtract(7, "days")
          .startOf("day")
          .isAfter(time);

        this.props.setHeader({
          title: "Ops > Payment",
          description: `${
            weekTest
              ? moment(fetchMoreResult.payments[0].created_at).calendar()
              : moment(fetchMoreResult.payments[0].created_at).fromNow()
          } - ${fetchMoreResult.payments[0].merchant.name}`,
        });
      },
    });
  }

  render() {
    const payment = this.state.data ? this.state.data : {};

    // Format Date
    const formatDate = (date) => {
      let DateObj = new Date(date);
      let formatFullDate = `${DateObj.getFullYear()}-${(
        "0" + (parseInt(DateObj.getMonth().toString(), 10) + 1).toString()
      ).slice(-2)}-${("0" + DateObj.getDate()).slice(-2)} ${(
        "0" + DateObj.getHours()
      ).slice(-2)}:${("0" + DateObj.getMinutes()).slice(-2)}:${(
        "0" + DateObj.getSeconds()
      ).slice(-2)}`;
      return <span>{formatFullDate}</span>;
    };

    //  STATUS FORMATING
    const formatStatusColour = (status) => {
      if (status === "completed") {
        return "#ebffeb";
      } else if (status === "pending") {
        return "white";
      } else if (status === "error") {
        return "#ffebeb";
      } else {
        return "white";
      }
    };

    //  SECURE 3D
    const formatSecure3D = (status3D) => {
      if (status3D) {
        return <i className="fa fa-lock fa-lg" style={{ color: "green" }} />;
      } else {
        return <i className="fa fa-minus fa-lg" style={{ color: "red" }} />;
      }
    };

    // Summary
    const Summary = () => {
      if (payment && Object.keys(payment).length > 0) {
        return (
          <tbody>
            <tr style={{ backgroundColor: formatStatusColour(payment.status) }}>
              <td> {formatDate(payment.created_at)} </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/users/${payment.device.user.external_reference}/payments`}
                >
                  {payment.device.user.email}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.device.user.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/merchants/${payment.merchant.id}/payments`}
                >
                  {payment.merchant.name}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.merchant.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/devices/${payment.device.external_reference}/summary`}
                >
                  {payment.device.phone_number}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.device.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/payments/${payment.reference}/summary`}
                >
                  {payment.payment_strategy}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>{formatSecure3D(payment.secure3d_requested)}</td>
            </tr>
          </tbody>
        );
      } else {
        return null;
      }
    };

    // PAYSERV
    const Payserv = () => {
      if (payment && Object.keys(payment).length > 0) {
        if (payment.payserv_payment) {
          return (
            <tbody>
              <tr>
                <td colSpan={4}>
                  <h3
                    style={{
                      borderBottom: "1px solid rgb(204, 204, 204)",
                      paddingBottom: "10px",
                      fontWeight: 400,
                    }}
                  >
                    Basic
                  </h3>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "5px", paddingLeft: 0 }}>
                  <b style={{ fontWeight: 400 }}>Date:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {formatDate(payment.payserv_payment.created_at)}{" "}
                </td>
                <td style={{ padding: "5px", paddingLeft: "20px" }}>
                  <b style={{ fontWeight: 400 }}>Bank response code:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {payment.payserv_payment.bank_response_code}{" "}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "5px", paddingLeft: 0 }}>
                  <b style={{ fontWeight: 400 }}>Type:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {payment.payserv_payment.type}{" "}
                </td>
                <td style={{ padding: "5px", paddingLeft: "20px" }}>
                  <b style={{ fontWeight: 400 }}>Message:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {payment.payserv_payment.message}{" "}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "5px", paddingLeft: 0 }}>
                  <b style={{ fontWeight: 400 }}>Reserve amount:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  R
                  {(
                    parseInt(payment.payserv_payment.reserve_amount, 10) / 100
                  ).toFixed(2)}{" "}
                </td>
                <td style={{ padding: "5px", paddingLeft: "20px" }}>
                  <b style={{ fontWeight: 400 }}>Finalize amount:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  R
                  {(
                    parseInt(payment.payserv_payment.finalize_amount, 10) / 100
                  ).toFixed(2)}{" "}
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  <h3
                    style={{
                      borderBottom: "1px solid rgb(204, 204, 204)",
                      paddingBottom: "10px",
                      fontWeight: 400,
                    }}
                  >
                    Details
                  </h3>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "5px", paddingLeft: 0 }}>
                  <b style={{ fontWeight: 400 }}>PSP:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {payment.payserv_payment.psp}{" "}
                </td>
                <td style={{ padding: "5px", paddingLeft: "20px" }}>
                  <b style={{ fontWeight: 400 }}>PSP reference:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {payment.payserv_payment.psp_reference}{" "}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "5px", paddingLeft: 0 }}>
                  <b style={{ fontWeight: 400 }}>Terminal identifier:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {payment.payserv_payment.terminal_identifier}{" "}
                </td>
                <td style={{ padding: "5px", paddingLeft: "20px" }}>
                  <b style={{ fontWeight: 400 }}>Strategy:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {payment.payserv_payment.strategy}{" "}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "5px", paddingLeft: "0" }}>
                  <b style={{ fontWeight: 400 }}>
                    Card acceptor name location:
                  </b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {payment.payserv_payment.card_acceptor_name_location}{" "}
                </td>
                <td style={{ padding: "5px", paddingLeft: "20px" }}>
                  <b style={{ fontWeight: 400 }}>External reference:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {payment.payserv_payment.external_reference}{" "}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "5px", paddingLeft: 0 }}>
                  <b style={{ fontWeight: 400 }}>Recon identifier:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {payment.payserv_payment.recon_identifier}{" "}
                </td>
                <td style={{ padding: "5px", paddingLeft: "20px" }}>
                  <b style={{ fontWeight: 400 }}>Retrieval reference number:</b>
                </td>
                <td style={{ padding: "5px" }}>
                  {" "}
                  {payment.payserv_payment.retrieval_reference_number}{" "}
                </td>
              </tr>
            </tbody>
          );
        } else {
          return (
            <tbody>
              <tr>
                <td colSpan={4}>
                  <h3
                    style={{
                      paddingBottom: "10px",
                      fontWeight: 400,
                      textAlign: "center",
                    }}
                  >
                    <i
                      style={{ marginRight: "8px" }}
                      className="fa fa-exclamation-triangle"
                    />
                    Payserv not available
                  </h3>
                </td>
              </tr>
            </tbody>
          );
        }
      } else {
        return null;
      }
    };

    const PayservError = () => {
      if (payment && Object.keys(payment).length > 0) {
        if (
          payment.payserv_payment &&
          payment.payserv_payment.error_reason !== null &&
          payment.payserv_payment.error_reason !== ""
        ) {
          return (
            <table
              style={{
                fontSize: "14px",
                paddingTop: "10px",
                width: "100%",
              }}
              className="BOTable"
              cellSpacing={0}
              cellPadding={0}
            >
              <thead>
                <tr>
                  <td colSpan={4}>
                    <h3
                      style={{
                        borderBottom: "1px solid rgb(204, 204, 204)",
                        paddingBottom: "10px",
                        fontWeight: 400,
                      }}
                    >
                      Error
                    </h3>
                  </td>
                </tr>
                <tr>
                  <th>
                    <b style={{ color: "#555" }}>Error reason</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Error message</b>
                  </th>
                </tr>
              </thead>
              <tbody
                style={{
                  backgroundColor: "#ffebeb",
                }}
              >
                <tr>
                  <td style={{ padding: "5px" }}>
                    {" "}
                    {payment.payserv_payment.error_reason}{" "}
                  </td>
                  <td style={{ padding: "5px" }}>
                    {" "}
                    {payment.payserv_payment.error_message}{" "}
                  </td>
                </tr>
              </tbody>
            </table>
          );
        } else {
          return null;
        }
      } else {
        return null;
      }
    };

    return (
      <div>
        <div className="DetailTopBar">
          <BOText
            text="Summary"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/summary`}
            active="selected"
          />
          <BOText
            text="Details"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/details`}
            active="selected"
          />
          <BOText
            text="Pay"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/pay`}
            active="selected"
          />
          <BOText
            text="Pay requests"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/pay_requests`}
            active="selected"
          />
        </div>

        <section className="padded">
          <div
            style={{
              height: "calc(100vh - 120px)",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <table
              style={{
                fontSize: "14px",
                paddingTop: "10px",
                width: "100%",
              }}
              className="BOTable"
              cellPadding={0}
              cellSpacing={0}
            >
              <thead>
                <tr>
                  <th>
                    <b style={{ color: "#555" }}>Date</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>User</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Merchant</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Device</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>Payment</b>
                  </th>
                  <th>
                    <b style={{ color: "#555" }}>3DS</b>
                  </th>
                </tr>
              </thead>
              {Summary()}
            </table>

            <table
              style={{
                fontSize: "14px",
                paddingTop: "10px",
                width: "100%",
              }}
              cellSpacing={0}
              cellPadding={0}
            >
              {Payserv()}
            </table>

            {PayservError()}
          </div>
        </section>
      </div>
    );
  }
}

const Currentlist = gql`
  query Currentlist($reference: String) {
    payments(reference: $reference) {
      created_at
      reference
      snapmin_url
      payment_strategy
      status
      secure3d_requested
      merchant {
        name
        id
        snapmin_url
      }
      device {
        created_at
        phone_number
        snapmin_url
        external_reference
        user {
          email
          external_reference
          snapmin_url
        }
      }
      payserv_payment {
        bank_response_code
        card_acceptor_name_location
        config
        created_at
        error_message
        error_reason
        external_reference
        finalize_amount
        message
        psp
        psp_reference
        recon_identifier
        refund_amount
        reserve_amount
        retrieval_reference_number
        strategy
        terminal_identifier
        type
      }
    }
  }
`;

const paymentPayWithGraphql = graphql(Currentlist, {
  options(props: any) {
    return {
      variables: {
        reference: props.match.params.id,
      },
    };
  },
})(Summary);
export default paymentPayWithGraphql;
